export const parentNode = (element: Node): Node & ParentNode | null => {
  const parentElement = element.parentElement || element.parentNode;

  if (parentElement && parentElement.nodeType !== 1) {
    return parentElement;
  }

  return null;
};
